import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from 'contexts/AuthContext';

export interface SubscriptionResponse {
  id: string;
  entity: string;
  plan_id: string;
  status: string;
}

export interface CreateSubscriptionParams {
  workspaceId: string;
  planName: string;
}

export const useCreateSubscription = () => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();

  return useMutation<SubscriptionResponse, Error, CreateSubscriptionParams>({
    mutationFn: async ({ workspaceId, planName }) => {
      if (!planName) {
        throw new Error('Please select a plan');
      }
      
      const response = await authApi.post(`/workspace/${workspaceId}/subscribe`, {
        planName
      });
      
      if (!response.data.id) {
        throw new Error('No subscription id received from API');
      }
      
      return response.data as SubscriptionResponse;
    },
    onSuccess: () => {
      // Invalidate subscription queries for this workspace
      queryClient.invalidateQueries({ queryKey: ['subscription'] });
    },
    onError: (error: Error) => {
      console.error('Error creating subscription:', error);
    }
  });
};
